import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Icon from '../icon';
import CitedByButtonContainer from './citedBy/citedByButtonContainer';
import ExtrasPopoverContainer from '../extras/extrasPopoverContainer';
import OutlineButtonContainer from './outline/outlineButtonContainer';
import FiguresButtonContainer from './figuresButton/figuresButtonContainer';
import SliderButton from './enhancementSliderButton/enhancementSliderButton';
import { returnArrowsState } from '../../utils/arrowsUtils';
import BurgerMenu from './burgerMenu/burgerMenu';
import { SIDE_PANEL_TRANSITION } from '../../constants';

export default class EnhancementButtons extends Component {
  constructor() {
    super();
    this.state = {
      leftArrow: false,
      rightArrow: false,
    };
    this.listContainer = React.createRef();
    this.buttonList = React.createRef();

    this.handleLeftClick = this.handleLeftClick.bind(this);
    this.handleRightClick = this.handleRightClick.bind(this);
  }

  componentDidUpdate(prevProps) {
    /* This is required to hide the arrow after closing the side panel,
    as the toolbar will slide wider over 0.3s */
    const { sidePanelOpen } = this.props;
    if (prevProps.sidePanelOpen && !sidePanelOpen) {
      setTimeout(() => this.setState({}), SIDE_PANEL_TRANSITION);
    }
  }

  static getDerivedStateFromProps(props, state) {
    return returnArrowsState(props, state);
  }

  updateScrollLeft(distance) {
    const starttime = Date.now();

    const step = () => {
      const runtime = Date.now() - starttime;
      const progress = runtime / SIDE_PANEL_TRANSITION;
      this.listContainer.current.scrollLeft = distance > 0
        ? distance * progress
        : distance * (progress - 1);

      if (runtime < SIDE_PANEL_TRANSITION) {
        window.requestAnimationFrame(step);
      }
    };

    window.requestAnimationFrame(step);
  }

  handleLeftClick() {
    const { leftArrow } = this.state;
    const { listContainerWidth, buttonListWidth } = this.props;
    if (leftArrow === true) { // Check for onFocus
      this.setState({
        leftArrow: false,
        rightArrow: true,
      });

      const distance = listContainerWidth - buttonListWidth;
      this.updateScrollLeft(distance);
    }
  }

  handleRightClick() {
    const { rightArrow } = this.state;
    const { buttonListWidth, listContainerWidth } = this.props;
    if (rightArrow === true) { // Check for onFocus
      this.setState({
        leftArrow: true,
        rightArrow: false,
      });
      const distance = buttonListWidth - listContainerWidth;
      this.updateScrollLeft(distance);
    }
  }

  render() {
    const { sidePanelOpen } = this.props;
    const { leftArrow, rightArrow } = this.state;
    const outlineButton = <OutlineButtonContainer onFocus={this.handleLeftClick} />;
    const citedByButton = <CitedByButtonContainer />;
    const figuresButton = <FiguresButtonContainer />;
    const extrasPopover = <ExtrasPopoverContainer />;

    return (
      <div
        id="enhancement-submenu"
        className={classnames({
          'side-panel-open': sidePanelOpen,
        })}
      >
        <div id="enhancement-buttons" className="enhancement-buttons">
          <SliderButton
            className="enhancement-slider-button-left"
            icon={Icon.NavigateLeft}
            onClick={this.handleLeftClick}
            render={leftArrow}
          >
            Show left
          </SliderButton>

          <div
            className="button-list-container"
            id="list-container"
            ref={this.listContainer}
          >
            <ol
              id="toolbar-button-list"
              className="button-list"
              ref={this.buttonList}
            >
              <li>{outlineButton}</li>
              <li>{citedByButton}</li>
              <li>{figuresButton}</li>
              <li>{extrasPopover}</li>
            </ol>
          </div>

          <SliderButton
            className="enhancement-slider-button-right"
            icon={Icon.NavigateRight}
            onClick={this.handleRightClick}
            render={rightArrow}
          >
            Show right
          </SliderButton>
        </div>
        <BurgerMenu
          className="enhancement-burger-menu"
          reset={sidePanelOpen}
        >
          {outlineButton}
          {citedByButton}
          {figuresButton}
        </BurgerMenu>
      </div>
    );
  }
}

EnhancementButtons.propTypes = {
  buttonListWidth: PropTypes.number.isRequired,
  listContainerWidth: PropTypes.number.isRequired,
  sidePanelOpen: PropTypes.bool,
};

EnhancementButtons.defaultProps = {
  sidePanelOpen: false,
};
